<div class="grid grid-cols-10 gap-4 align-middle w-full h-20 py-2 pl-4 bg-[#182256] border-t-2 border-white ">

  <div class="col-span-10 flex flex-row gap-4 align-middle">
    <div class="justify-content-center">
      <p class="text-white flex items-center text-xs w-">Seleccionar oficina:</p>
      <p-multiSelect [options]="listOffices" [(ngModel)]="selectedOffice" [showToggleAll]="true"
        styleClass="h-10 items-center max-w-60" styleClass="p-multiselect-open xl:w-60 md:w-32" optionLabel="name" (onChange)="optionsSelectionChange($event)"></p-multiSelect>
    </div>

    <div class="justify-content-center">
      <p class="text-white flex items-center text-xs w-">Seleccionar fecha:</p>
      <p-calendar styleClass="h-10 items-center w-32" styleClass="p-multiselect-open xl:w-60 md:w-32" [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true" [showIcon]="true"
        dateFormat="d/m/yy" [showButtonBar]="true" (onSelect)="optionsSelectionChange($event)"></p-calendar>
    </div>

    <div class="justify-content-center">
      <p class="text-white flex items-center text-xs">Seleccionar actividad:</p>
      <p-multiSelect [options]="listServices" [(ngModel)]="selectedService" optionLabel="name" [showToggleAll]="true"
        styleClass="h-10 items-center xl:w-60 md:w-32" (onChange)="optionsSelectionChange($event)"></p-multiSelect>
    </div>

    <div class="justify-content-center align-middle items-center">
      <p class="text-white flex items-center text-xs">Participantes:</p>
      <p-multiSelect [options]="listCapacity" [(ngModel)]="selectedCapacity" optionLabel="name"
        styleClass="h-10 items-center xl:w-60 md:w-32"(onChange)="optionsSelectionChange($event)"></p-multiSelect>
    </div>

    <div class="flex flex-row align-middle items-center justify-end gap-3">
      <p class="text-white flex mt-2">Limpiar filtros</p>
      <button type="reset"
        class="button-reset h-12 w-12 rounded text-white flex justify-center align-middle items-center" (click)="clearFilters()">
        <img class="h-6 w-6 flex justify-content-center" src="/assets/icons/icon-eraser.png" alt="">
      </button>
    </div>
  </div>
</div>
